import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";

interface BodyClassToggleProps {
    clazz: string
}

@Dce("BodyClassToggle")
export default class BodyClassToggle extends DceComponent<BodyClassToggleProps> {

    constructor(elem: DceHTMLElement, props: BodyClassToggleProps) {
        super(elem, props);

        this.elem.addEventListener('click', evt => {

            if(document.body.classList.contains(props.clazz)){
                document.body.classList.remove(props.clazz);
            }else{
                document.body.classList.add(props.clazz);
            }

        });

    }

}